import { DatePicker, DatePickerProps } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

type FormattedDatePickerProps = Omit<DatePickerProps, 'picker'>;

const dateFormatList = ['DD.MM.YYYY', 'D.M.YYYY'];

/**
 * Limit the date picker to only allow dates today and future as
 * the ScheduledArchivedOn date cannot be set to the past.
 * @param current
 */
const disabledDate = (current: dayjs.Dayjs | null) => {
  return current ? current.isBefore(dayjs().startOf('day')) : false;
};

export const FormattedDatePicker: React.FC<FormattedDatePickerProps> = props => {
  const { value, onChange, ...restProps } = props;

  return (
    <DatePicker
      value={value}
      onChange={onChange}
      disabledDate={disabledDate}
      format={dateFormatList}
      {...restProps}
    />
  );
};
